<template>
  <div class="personaContainer">
    <customDialog
      v-if="isShowDialog"
      :scorllTopVaule="scorllTopVaule"
      @closeDialog="closeDialog"
    ></customDialog>
    <div class="headPortrait_box">
      <div class="avatar">
        <div class="avatar-img" @click="change_headPortrait">
          <img
            :src="
              userInfo.photo || this.publicData.serverUrl + 'images/pig.jpg'
            "
          />
          <div class="uploading">
            <i class="el-icon-camera-solid"></i>
          </div>
        </div>
        <p>{{ userInfo.stuName }}</p>
      </div>
    </div>
    <userAllContainer></userAllContainer>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import userAllContainer from './showUser_all_Info_Container/user_all_info_container.vue'
import customDialog from '../../views/customDiaLog/customDialog.vue'

export default {
  name: 'personal_dialog',
  components: {
    customDialog,
    userAllContainer,
  },
  props: [],
  data() {
    return {
      nickname: 'INVINCIBLE',
      isShowDialog: false,
      scorllTopVaule: 0,
    }
  },
  watch: {},
  computed: {
    ...mapState(['userLogin', 'userInfo']),
  },
  created() {},
  mounted() {},
  methods: {
    errorHandler() {
      return true
    },
    change_headPortrait() {
      //弹窗选择头像
      this.isShowDialog = true
      this.scorllTopVaule =
        document.documentElement.scrollTop -
        Math.ceil(document.documentElement.scrollTop / 10)
    },
    closeDialog(e) {
      this.isShowDialog = e
    },
    scrollEvent(e) {
      console.log(e)
    },
  },
}
</script>

<style lang='scss' scoped>
.personaContainer {
  width: 100%;
  position: relative;
  .avatar {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    &-img {
      position: relative;
      cursor: pointer;
      .uploading {
        position: absolute;
        right: 5px;
        bottom: 5px;
        width: 25px;
        height: 25px;
        text-align: center;
        background-color: #ffffff;
        border-radius: 4px;
        i {
          font-weight: bold;
          font-size: 16px;
          line-height: 25px;
          color: var(--default-color);
        }
      }
      img {
        width: 120px;
        height: 120px;
        border: 3px solid #fff;
        border-radius: 50%;
      }
    }
    p {
      margin-bottom: 0;
      text-align: center;
      color: #ffffff;
      font-size: 24px;
    }
  }
}
.headPortrait_box {
  width: 100%;
  height: 350px;
  position: relative;
  background-color: #000;
  background-image: var(--personal-bg);
  background-size: 100% 100%;
}
</style>